/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserCreateCourseRef } from './userCreateCourseRef';

export type UserCreateCourse = UserCreateCourseRef | null;
